module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-container"
  }, [_c('StepHeader', {
    attrs: {
      "currentStep": _vm.currentStep,
      "steps": _vm.steps
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "scenarios-grid"
  }, [_c('div', {
    staticClass: "scenarios-column"
  }, [_c('h3', {
    staticClass: "column-title"
  }, [_vm._v(_vm._s(_vm.lang.W00032))]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-container"
  }, [_c('div', {
    staticClass: "wizard-table-header"
  }, [_c('div', [_vm._v(_vm._s(_vm.lang.W00035))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.W00034))])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-body"
  }, _vm._l((_vm.availableScenarios), function(scenario) {
    return _c('div', {
      key: scenario.ScenarioId,
      staticClass: "wizard-table-row",
      class: {
        'disabled': (scenario.disabled || _vm.readonly),
        'selectable': (!scenario.disabled && !_vm.readonly)
      },
      on: {
        "click": function($event) {
          return _vm.selectScenario(scenario)
        }
      }
    }, [_c('div', {
      staticClass: "wizard-table-cell"
    }, [_vm._v(_vm._s(scenario.ScenarioId))]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-cell"
    }, [_vm._v(_vm._s(scenario.ScenarioName))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "scenarios-column selected-column"
  }, [_c('div', {
    staticClass: "selected-content"
  }, [_c('div', {
    staticClass: "selected-header"
  }, [_c('h3', {
    staticClass: "column-title"
  }, [_vm._v(_vm._s(_vm.lang.W00033))]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-container"
  }, [_c('div', {
    staticClass: "wizard-table-header"
  }, [_c('div', [_vm._v(_vm._s(_vm.lang.W00035))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.W00034))])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-body"
  }, _vm._l((_vm.localFormData.scenarios), function(scenario) {
    return _c('div', {
      key: scenario.ScenarioId,
      staticClass: "wizard-table-row selected"
    }, [_c('div', {
      staticClass: "wizard-table-cell"
    }, [_vm._v(_vm._s(scenario.ScenarioId))]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-cell"
    }, [_vm._v(_vm._s(scenario.ScenarioName))]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-cell"
    }, [_c('button', {
      staticClass: "remove-button",
      attrs: {
        "disabled": _vm.readonly
      },
      on: {
        "click": function($event) {
          return _vm.removeScenario(scenario.ScenarioId)
        }
      }
    }, [_c('svg', {
      staticClass: "remove-icon",
      attrs: {
        "fill": "none",
        "viewBox": "0 0 24 24",
        "stroke": "#666666"
      }
    }, [_c('path', {
      attrs: {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.5",
        "d": "M6 18L18 6M6 6l12 12"
      }
    })])])])])
  }), 0)])])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ffa4654e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wizards/Audi/Step2.vue
// module id = 1743
// module chunks = 1